import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
import { getCompanyMapKey } from './mappers';
const initialState = {};
const upsertIntoState = (state, companies) => {
    companies.forEach(company => {
        var _a, _b;
        const key = getCompanyMapKey(company);
        if (!key) {
            return;
        }
        const existing = state[key];
        state[key] = Object.assign(Object.assign({}, company), { id: key, listId: (_b = (_a = company.listId) !== null && _a !== void 0 ? _a : existing === null || existing === void 0 ? void 0 : existing.listId) !== null && _b !== void 0 ? _b : null });
    });
};
const slice = createSlice({
    name: 'COMPANIES',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        setCompany(state, { payload }) {
            upsertIntoState(state, [payload]);
        },
        setCompanies(state, { payload }) {
            upsertIntoState(state, payload);
        },
        updateCompany(state, { payload }) {
            const existing = state[payload.key];
            if (existing) {
                state[payload.key] = Object.assign(Object.assign({}, existing), payload.changes);
            }
        },
        setCompanyEmployees(state, { payload }) {
            const existing = state[payload.key];
            if (existing) {
                state[payload.key].employeeIds = payload.list;
            }
        },
        setListId(state, { payload }) {
            if (!payload.id) {
                return;
            }
            const existing = state[payload.id];
            if (!existing) {
                return;
            }
            state[payload.id] = Object.assign(Object.assign({}, existing), { listId: payload.listId });
        },
        removeCompany(state, { payload }) {
            delete state[payload];
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
